import { Component, Input, OnInit } from '@angular/core';
import { API, GeoCullDTO, Pagination, PlayerCullDTO, ScreenScope } from '../../../services/api/api';
import { BehaviorSubject } from 'rxjs';
import { UtilService } from '../../../services/util.service';

@Component({
  selector: 'sb-comp-inventory-sublist',
  templateUrl: './inventory-sublist.component.html',
  styleUrls: ['./inventory-sublist.component.scss'],
  standalone: false,
})
export class InventorySublistComponent implements OnInit {
  @Input() cartFilter: any;

  @Input() playerCull: PlayerCullDTO;
  @Input() geoCull: GeoCullDTO;
  @Input() screenScope: string;

  @Input() filter = [];

  sublistItems: any[] = [];
  resultCount: number;
  maxSize: number;
  paginationString: string;
  boundaryLinks: boolean = true;
  collectionSize: number;
  pagination: BehaviorSubject<Pagination>;
  _page: number = 1;

  paginationInitialized: boolean = false;
  sizes: number[] = [8, 12, 16, 20, 24];

  constructor(
    private api: API,
    public util: UtilService
  ) {}

  get page(): number {
    return this._page;
  }

  set page(val: number) {
    this._page = val;
    this.pagination.value.page = val;
  }

  pageChange($event) {
    this.page = $event;
    this.refreshFromServer();
  }

  setMaxSize(size) {
    this.maxSize = size;
    this.pagination.value.count = size;
    this.refreshFromServer();
  }

  ngOnInit(): void {
    this.initPagination();
  }

  initPagination() {
    this.pagination = new BehaviorSubject<Pagination>({
      page: this.page,
      count: this.maxSize ? this.maxSize : 8,
      pages: -1,
      resultcount: -1,
    });
    this.pagination.subscribe((e: Pagination) => {
      this.collectionSize = e.resultcount;
      this.maxSize = e.count;
      this.resultCount = e.resultcount;
      // this.page = e.page;
    });
    this.refreshFromServer();
  }

  refreshFromServer() {
    this.api
      .ds_rm_Inventory_list(
        {
          filters: this.filter,
          whitelistPolygons: null,
          blacklistPolygons: null,
          playerCulls: this.playerCull ? [this.playerCull] : null,
          geoCulls: this.geoCull ? [this.geoCull] : null,
          descriptorId: null,
        },
        { screenScope: this.screenScope ? ScreenScope[this.screenScope] : null },
        this.pagination
      )
      .subscribe(data => {
        this.sublistItems = data;
        this.paginationString = this.util.getPaginationString(this.page, this.maxSize, this.sublistItems.length, this.resultCount);
        this.paginationInitialized = true;
      });
  }
}
